module.exports = "<p>תוכלו לכתוב הערות על כל מודעה באמצעות הפתק הצהוב ״הוסף הערות״ שבמודעה. במידה ואתם רשומים לאתר, המידע ישמר ויחכה לכם גם בפעם הבאה שתתחברו.</p> ";


//////////////////
// WEBPACK FOOTER
// ./src/translations/help/he/13.md
// module id = 803
// module chunks = 0